import type { ReactNode } from "react"

import { cn } from "../lib/cn"
import { ComDica } from "./ComDica"

export function Numeros({ children }: { children: ReactNode }) {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(min(10.5rem,100%),1fr))]">
      {children}
    </div>
  )
}

export function Numero({
  rotulo,
  valor,
  nota,
  dica,
  aoAbrir,
  destaque = false,
  tom,
}: {
  rotulo: string
  valor: string
  nota?: string
  dica?: string
  aoAbrir?: () => void
  destaque?: boolean
  tom?: "critico"
}) {
  const miolo = (
    <>
      <span className="flex min-w-0 items-center gap-1 text-sm">
        <span
          className={cn(
            "truncate",
            aoAbrir === undefined ? "text-primary" : "text-muted-foreground group-hover:text-primary",
          )}
        >
          {rotulo}
        </span>
        {dica !== undefined && aoAbrir === undefined && <ComDica dica={dica} />}
      </span>
      <span
        className={cn(
          "text-xl leading-[1.2] font-bold tabular-nums",
          destaque && "text-primary",
          tom === "critico" && "text-status-erro",
        )}
      >
        {valor}
      </span>
      {nota !== undefined && (
        <span data-slot="numero-nota" className="truncate text-xs text-muted-foreground" title={nota}>
          {nota}
        </span>
      )}
    </>
  )
  const classeComum = cn(
    "group flex min-w-0 flex-col gap-0.5 border-r border-r-border border-t-[3px] bg-card px-3.5 py-2 text-left last:border-r-0 max-[901px]:border-r-0 max-[901px]:border-b max-[901px]:border-b-border border-t-transparent",
  )
  if (aoAbrir === undefined) {
    return (
      <div data-slot="numero" className={classeComum}>
        {miolo}
      </div>
    )
  }
  return (
    <button
      type="button"
      data-slot="numero"
      className={cn(classeComum, "cursor-pointer hover:bg-azul-50")}
      onClick={aoAbrir}
    >
      {miolo}
    </button>
  )
}
